//pcombinator-frontend-npm6node14/src/pages/Login.jsx
import React from 'react';
import LoginForm from '../components/auth/LoginForm';

const Login = () => {
  return (
    <div className="container">
      <LoginForm />
    </div>
  );
};

export default Login;
